import * as React from 'react';

import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';

import { VariantProps, cva } from 'class-variance-authority';

import { cn } from '../lib';

const radioGroupItemVariants = cva(
  'aspect-square rounded-full border-[2px] focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        default:
          'data-[state=checked]:border-primary border-contrast-300 text-base-300 data-[state=checked]:text-primary',
        secondary:
          'border-icon-base-500 data-[state=checked]:border-contrast-500 text-base-500 data-[state=checked]:text-base-500',
        dashboard:
          'border-icon-base-100 data-[state=checked]:border-contrast-500 text-base-500 data-[state=checked]:text-base-500',
      },
      size: {
        default: 'h-[22px] min-h-[22px] w-[22px] min-w-[22px]',
        md: 'size-5 [&>span>svg]:size-3.5',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);
const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Root
      className={cn('grid gap-2', className)}
      {...props}
      ref={ref}
    />
  );
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

interface RadioGroupItemProps
  extends React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>,
    VariantProps<typeof radioGroupItemVariants> {}

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  RadioGroupItemProps
>(({ className, variant, size, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(radioGroupItemVariants({ variant, size, className }))}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
        <div className="h-3.5 w-3.5 rounded-full bg-current" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
